import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import TourForm from "./AddTour";

export default function EditTour() {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <TourForm
      isEdit={true}
      tourId={id}
      onSuccess={() => navigate("/list-tours")}
    />
  );
}